import type { Messages } from './en';

export const MESSAGES_ES: Messages = {
  secure_tagadapay: 'Pago Seguro por Tagada',
  checkout_title: 'Pago Seguro',
  checkout_subtitle: 'Complete su compra de forma segura',
  express_payment: 'Pago Express',
  express_payment_apple_pay: 'Pagar con Apple Pay',
  express_payment_subtitle: 'Saltar el formulario de pago',
  informations_title: 'Información',
  informations_subtitle: 'Ingrese su información personal',
  shipping_address_title: 'Dirección de Envío',
  shipping_address_subtitle: 'Ingrese su dirección de envío',
  shipping_method_title: 'Método de Envío',
  shipping_method_subtitle: 'Seleccione su método de envío a continuación',
  shipping_method_warning_title: 'Información',
  shipping_method_warning_text: 'No se encontraron métodos de envío en su país',
  billing_address_check: 'La dirección de facturación es diferente a la dirección de envío',
  billing_method_title: 'Método de Facturación',
  billing_method_subtitle: 'Ingrese su dirección de facturación',
  payment_title: 'Pago',
  payment_subtitle:
    'Seleccione su método de pago a continuación. Todas las transacciones son seguras y encriptadas',
  payment_credit_card: 'Tarjeta de crédito o débito',
  payment_credit_card_subtitle: 'Pago seguro por tarjeta bancaria',
  payment_paypal_subtitle: 'Pago seguro y rápido con PayPal',
  payment_bridge_subtitle: 'Pago seguro y rápido con Bridge',
  payment_klarna_subtitle: 'Pago seguro y rápido con Klarna',
  payment_generic_subtitle: 'Pago seguro y rápido',
  default_payment_method_short: 'Por defecto',
  order_summary_discount_code: 'Código de descuento',
  order_summary_discount_discovered_callout: 'Hemos encontrado códigos de descuento para ti',
  order_summary_discount_discovered_callout_action: 'Agrégalos todos',
  order_summary_title: 'Su pedido',
  order_summary_subtotal: 'Subtotal',
  order_summary_shipping: 'Envío',
  order_summary_discount: 'Descuento',
  order_summary_tax: 'Impuestos estimados',
  order_summary_total: 'Total',
  order_summary_total_savings: 'Ahorro Total',
  button_pay: 'Pagar ahora',
  button_pay_with_gateway: 'Pagar con {gateway}',
  loading: 'Cargando...',
  error_missing_checkout_session_id: 'Falta el ID de la sesión de pago',
  error_checkout_session_not_found: 'Sesión de pago no encontrada',
  error_order_already_completed: 'Pedido ya completado',
  error_checkout_session_items_empty: 'Su carrito está vacío',
  order_not_found: 'Pedido no encontrado',
  thank_you_title: '¡Gracias por su pedido!',
  thank_you_subtitle: 'Su pedido ha sido procesado con éxito.',
  thank_you_email_sent: 'Hemos enviado un correo de confirmación a su dirección de correo electrónico:',
  thank_you_order_details: 'Detalles del Pedido',
  thank_you_reference: 'Referencia',
  thank_you_date: 'Fecha',
  thank_you_total: 'Total',
  thank_you_button_continue: 'Continuar Comprando',
  term_and_privacy_clicking_text: 'Al hacer clic, acepto',
  term_and_condition_link_text: 'Términos y Condiciones',
  privacy_policy_link_text: 'Política de Privacidad',
  refund_policy_link_text: 'Política de Reembolso',
  shipping_policy_link_text: 'Política de Envío',
  billed_as_text: 'Su tarjeta de crédito será cargada como {domain}.',
  you_must_accept_policies: 'Debe aceptar nuestras',
  and: 'y',
  comma: ',',
  payment_error_title: 'Error',
  checkout_preview_title: 'Modo Vista Previa - Esta es una página de pago en borrador',
  order_summary_discount_code_apply_button: 'Aplicar',
  optional: 'Opcional',
  field_phone: 'Teléfono',
  field_phone_placeholder: 'Ingrese su número de teléfono',
  field_phone_required_text: 'El número de teléfono es requerido',
  field_company: 'Empresa',
  field_company_placeholder: 'Ingrese el nombre de su empresa',
  checkbox_billing_address: 'La dirección de facturación es diferente a la dirección de envío',
  billing_address_title: 'Dirección de Facturación',
  billing_address_subtitle: 'Ingrese su dirección de facturación',
  field_first_name: 'Nombre',
  field_first_name_placeholder: 'Ingrese su nombre',
  field_first_name_error_message: 'Este campo es requerido',
  field_last_name: 'Apellido',
  field_last_name_placeholder: 'Ingrese su apellido',
  field_last_name_error_message: 'Este campo es requerido',
  field_address: 'Dirección',
  field_address_placeholder: '123 Calle Principal, Ciudad, País',
  field_address_error_message: 'Este campo es requerido',
  field_additional_address: 'Dirección Adicional',
  field_additional_address_placeholder: 'Apartamento, suite, unidad, etc.',
  field_additional_address_error_message: 'Este campo es requerido',
  field_city: 'Ciudad',
  field_city_placeholder: 'Ingrese su ciudad',
  field_city_error_message: 'Este campo es requerido',
  field_country: 'País',
  field_country_error_message: 'Este campo es requerido',
  field_state: 'Estado',
  field_state_placeholder: 'Ingrese su estado',
  field_state_error_message: 'Este campo es requerido',
  field_postal_code: 'Código Postal',
  field_postal_code_placeholder: 'Ingrese su código postal',
  field_postal_code_error_message: 'Este campo es requerido',
  field_email: 'Correo Electrónico',
  field_email_placeholder: 'Ingrese su correo electrónico',
  field_email_error_message: 'Este campo es requerido',
  credit_card_method: 'Tarjeta de crédito o débito',
  card_error_message: 'Información de tarjeta inválida',
  card_number: 'Número de tarjeta',
  card_number_placeholder: 'Ingrese su número de tarjeta',
  card_number_error_message: 'Este campo es requerido',
  expiry_date: 'Fecha de vencimiento',
  expiry_date_placeholder: 'MM/AA',
  expiry_date_error_message: 'Este campo es requerido',
  expiry_date_error_message_expired: 'La fecha de vencimiento ha pasado',
  cvc: 'CVC/CVV',
  cvc_placeholder: '123',
  cvc_error_message: 'El CVC debe tener 3 o 4 dígitos',
  payment_methods_loading_error: 'Error al cargar los métodos de pago',
  recommanded: 'Recomendado',
  free: 'Gratis',
  customer_update_error: 'Error al actualizar la información',
  shipping_method_empty_country: 'Seleccione un país para ver los métodos de envío disponibles',
  shipping_method_update_error: 'Error al actualizar la información del método de envío',
  items: '{count} artículos',
  back: 'Volver',
  continue_to_shipping: 'Continuar al envío',
  continue_to_payment: 'Continuar al pago',
  contact_title: 'Contacto',
  contact_title_subtitle: 'Ingrese su información de contacto',
  pay_now: 'Pagar ahora',
  secure_payment_message: 'Todas las transacciones son seguras y encriptadas',
  interval_day: 'día',
  interval_week: 'semana',
  interval_month: 'mes',
  interval_year: 'año',
  interval_day_plural: 'días',
  interval_week_plural: 'semanas',
  interval_month_plural: 'meses',
  interval_year_plural: 'años',
  every_interval: 'Cada {count} {interval}',
  billing_every_interval: 'Facturación cada {count} {interval}',
  delivery_every_interval: 'Entrega cada {count} {interval}',
  free_trial_period: '{duration} {type} de prueba gratis',
  first_payment_free: 'Primer pago gratis',
  subscription_trial_notice:
    'Tu suscripción incluye un período de prueba gratuito. No se te cobrará nada hasta que finalice el período de prueba.',
  recurring_total_with_interval: 'Total recurrente (cada {count} {interval})',
  trial_ends_on: 'La prueba finaliza el {date}',
  billing_timing: 'Facturación: {timing}',
  billing_cycle_anchor: 'Anclaje del ciclo de facturación',
  field_marketing_label: 'Acepto recibir correos electrónicos de marketing',
  terms_acceptance_text: 'Al hacer clic, acepto',
  cart_title: 'Carrito',
  payment_failed_message: 'El pago ha fallado',
  email: {
    abandoned_checkout: {
      preview: 'Complete su compra',
      default_body: 'Notamos que dejó algunos artículos en su carrito. ¿Le gustaría completar su compra?',
      cart_title: 'Su Carrito',
      quantity: 'Cantidad',
      recurring: 'Recurrente cada {interval}',
      trial_period: '({duration} {type} de prueba)',
      subtotal: 'Subtotal',
      discounts: 'Descuentos',
      total: 'Total',
      cta_button: 'Completar su compra',
      footer_text:
        'Si tiene alguna pregunta, simplemente responda a este correo - siempre estamos felices de ayudar.',
    },
    order_paid: {
      // Add order paid email translations here when needed
    },
  },
  image_upload: {
    errors: {
      unauthorized: 'No autorizado',
      unsupported_content_type: 'Tipo de contenido no soportado',
      single_file_required: 'È richiesto un singolo file',
      file_too_big: 'El archivo es demasiado grande',
      non_image_file: 'Impossibile gestire file non immagine',
    },
  },
  promotion_code_invalid: 'Este código de descuento no es válido',
  applying: 'Aplicando...',
  processing_payment: 'Elaboración del pago...',
  select_country: 'Seleccione un país',
  select_state: 'Seleccione un estado',
  order_details: 'Detalles del pedido',
  order_number: 'Número de pedido',
  order_date: 'Fecha del pedido',
  email_confirmation: 'Confirmación por email',
  confirmation_sent_to: 'Email de confirmación enviado a',
  shipping_address: 'Dirección de envío',
  billing_address: 'Dirección de facturación',
  payment_successful: 'Pago exitoso',
  recurring_total: 'Total recurrente',
  payment_is_blacklisted: 'El pago está bloqueado',
  checkout_has_errors_title: 'Validación',
  checkout_has_errors: 'La información a continuación es inválida o falta',
  checkout_email_error: 'dirección de correo electrónico',
  checkout_shipping_address_error: 'dirección de envío',
  checkout_billing_address_error: 'dirección de facturación',
  checkout_shipping_rate_error: 'tarifa de envío',
  checkout_pickup_address_error: 'dirección de recogida',
  checkout_payment_info_error: 'información de pago',
  checkout_phone_error: 'número de teléfono',
  checkout_terms_error: 'no has aceptado los términos y condiciones',
  payment: {
    genericError: 'Payment failed. Please try again with a different payment method.',
  },
  error: {
    unexpected: 'An unexpected error occurred. Please try again.',
  },
  checkout_completed_title: 'Pago Completado',
  checkout_already_completed: 'Este pedido ya ha sido pagado',
  payment_completed: 'Pago Completado',
  apply_vip_offers: 'Pagar como VIP',
  confirm_vip_payment: 'Pagar',
  cancel_vip_offers: 'Cancelar ofertas VIP',
  vip_total_difference: 'Diferencia: {difference}',
  total_as_vip: 'VIP',
  vip_savings: 'Ahorro VIP',
  vip_savings_available: 'Ahorro VIP Disponible',
  vip_savings_confirmed: 'Ahorro VIP Aplicado',
  vip_savings_message: '¡Seleccione el pago VIP para desbloquear estos ahorros!',
  vip_savings_applied_message: '¡Está ahorrando {amount} con los beneficios VIP!',
  vip_offer_savings_confirmed: 'Oferta VIP aplicada',
  vip_offer_savings_available: 'Oferta VIP disponible',
  vip_offer_savings_message: 'Aplique la oferta VIP para ahorrar en su pedido',
  vip_offer_savings_applied_message: 'Ha ahorrado {amount} con la oferta VIP',
  apply_vip_offer: 'Pagar en tanto que VIP',
  cancel_vip_offer: 'Cancelar oferta VIP',
  you_save: 'Ahorras {amount}',
  you_save_on_order: 'Ahorras {amount} en tu pedido',
  you_save_available: 'Ahorra {amount} en tu pedido con la oferta VIP exclusiva',
  free_trial_then_price: 'Prueba gratuita de {duration} {type}, luego {price}/{interval}',
  free_trial_period_short: '{duration} {type} gratis',
  click_to_apply: 'Haga clic para aplicar',
  please_select_shipping_country: 'Por favor, seleccione un país para ver los métodos de envío disponibles',
  invalid_phone_number: 'Número de teléfono inválido',
  click_errors_to_navigate: 'Haga clic para navegar a la sección de error',
  pickup_point: 'Punto de Recogida',
  monday: 'Lunes',
  tuesday: 'Martes',
  wednesday: 'Miércoles',
  thursday: 'Jueves',
  friday: 'Viernes',
  saturday: 'Sábado',
  sunday: 'Domingo',
  promotion_code_usage_limit_reached: 'Este código promocional ha alcanzado su límite de uso',
  promotion_code_first_time_only: 'Este código promocional solo es válido para clientes nuevos',
  promotion_code_invalid_email:
    'Este código promocional no es válido para su dirección de correo electrónico',
  promotion_code_cannot_apply: 'Este código promocional no se puede aplicar',
  promotion_code_already_applied: 'Esta promoción ya está aplicada',
  promotion_code_expired: 'Este código promocional ha expirado',
  promotion_code_cannot_remove_auto: 'No se pueden eliminar las promociones aplicadas automáticamente',
  promotion_code_remove_failed: 'Error al eliminar el código promocional',
  remove: 'Eliminar',
  pickup_select_point: 'Seleccionar punto de recogida',
  pickup_select_point_description: 'Elige un punto de recogida cerca de ti',
  pickup_click_to_select: 'Haz clic para seleccionar',
  pickup_change_point: 'Cambiar punto de recogida',
  pickup_change: 'Cambiar',
  pickup_opening_hours: 'Horario de apertura',
  pickup_closed: 'Cerrado',
  pickup_point_error: 'Se produjo un error al seleccionar el punto de recogida',
  pickup_view_list: 'Vista de lista',
  pickup_view_map: 'Vista de mapa',
  pickup_open_map: 'Abrir mapa',
  pickup_open_map_description: 'Haz clic para abrir el mapa interactivo',
  pickup_no_points_found: 'No se encontraron puntos de recogida en esta área',
  cancel: 'Cancelar',
  order_confirmed: 'Pedido Confirmado',
  view_order_details: 'Ver Detalles del Pedido',
  back_to_portal: 'Volver al Portal',
  customer_details: 'Detalles del Cliente',
  customer_email: 'Correo Electrónico',
  customer_id_label: 'ID del Cliente',
  customer_first_name: 'Nombre',
  customer_last_name: 'Apellido',
  customer_locale: 'Idioma',
  marketing_consent: 'Preferencias de Marketing',
  marketing_accepted: 'Suscrito al marketing',
  marketing_declined: 'No suscrito al marketing',
  customer_created_at: 'Cliente Desde',
  order_status_label: 'Estado del Pedido',
  order_status_paid: 'Pagado',
  order_status_pending: 'Pendiente',
  order_status_cancelled: 'Cancelado',
  post_purchase: {
    title: 'Hemos encontrado estas ofertas especialmente para ti',
    view_deal: 'Ver oferta',
    get_deal_now: 'Obtener oferta',
    bundle_content: '{count, plural, =0 {ningún artículo} =1 {# artículo} other {# artículos}}',
    adding_to_cart: 'Procesando...',
    vip_only: 'Solo VIP',
    products: '{count, plural, =0 {Ningún producto} =1 {# producto} other {# productos}}',
    skip: 'saltar',
    skip_addition: 'ir a tu resumen',
    exclusive_offer: 'Oferta exclusiva única',
    offer_expires_in: 'La oferta expira en',
    minutes: 'min',
    save: 'Ahorra',
    secure_checkout: 'Pago seguro',
    safe_payment: 'Protección del comprador garantizada',
    limited_time_offer: 'Oferta por tiempo limitado',
    previous: 'Anterior',
    no_thanks: 'No gracias',
    offer_count: 'Oferta {current} de {total}',
    special_offer_title: 'Oferta especial para ti',
  },
  billing_plan: 'Plan de Facturación',
  customer: 'Cliente',
  current_period: 'Período Actual',
  trial_period: 'Período de Prueba',
  cancellation_notice: 'Aviso de Cancelación',
  subscription_cancellation_end_period: 'Esta suscripción se cancelará al final del período actual.',
  created: 'Creado',
  product_id: 'ID del Producto',
  resuming: 'Reanudando...',
  resume_subscription: 'Reanudar Suscripción',
  canceling: 'Cancelando...',
  cancel_subscription: 'Cancelar Suscripción',
  my_subscriptions: 'Mis Suscripciones',
  subscriptions: 'suscripciones',
  no_active_subscriptions: 'No tienes suscripciones activas.',
  active: 'Activo',
  trial: 'Prueba',
  loading_subscriptions: 'Cargando tus suscripciones...',
  qty: 'Cant',
  id: 'ID',
  by_canceling: 'Al cancelar, vas a:',
  lose_club_advantages: 'Perder todas las ventajas de ser miembro del club',
  lose_accumulated_credits: 'Perder todos los créditos que has acumulado hasta ahora',
  lose_promotion_code: 'Perder tu código de promoción personal con descuentos exclusivos en toda la tienda',
  confirm_proceed: '¿Estás seguro de que quieres continuar?',
  cancel_club_membership: 'Esto cancelará tu membresía del club al final del ciclo de facturación actual.',
  cancel_subscription_notice: 'Esto cancelará tu suscripción al final del ciclo de facturación actual.',
  keep_subscription: 'Mantener Suscripción',
  yes_lose_benefits: 'Sí, quiero perder todos los beneficios de ser miembro del Subclub',
  yes_cancel: 'Sí, Cancelar',
  cancel_subscription_title: 'Cancelar Suscripción',
  membership: 'Membresía',
  related_orders: 'Pedidos Relacionados',
  related_orders_description: 'Pedidos realizados a través de ofertas post-compra',
  order_status: 'Estado',
  order_total: 'Total',
  order_items: 'Artículos',
  order_type: 'Tipo',
  view_order: 'Ver Pedido',
  order_item_count: '{count, plural, =1 {# artículo} other {# artículos}}',
  related_order_from: 'De oferta {offerType}',
  no_related_orders: 'No hay pedidos relacionados',
  total_with_related_orders: 'Total con pedidos relacionados',
  discount_applied: 'Descuento aplicado',
  paid: 'Pagado',
  pending: 'Pendiente',
  processing: 'Procesando',
  cancelled: 'Cancelado',
  refunded: 'Reembolsado',
  vip_post_purchase: {
    title: '¡Aún tienes tiempo!',
    subtitle: '¡Suscríbete a nuestra membresía del club y gana a lo grande!',
    action_cancel: 'No, gracias',
    action_subscribe: 'Suscribirse',
    savings: 'Ahorras {amount}',
    offer_title: 'Oferta Exclusiva que No Puedes Perderte',
    offer_description: '',
  },
  shopify: {
    notes: {
      sendcloud_pickup: {
        id: 'ID de Punto de Recogida',
        name: 'Nombre de Punto de Recogida',
        street: 'Dirección de Punto de Recogida',
        type: 'Tipo de Punto de Recogida',
        city: 'Ciudad de Punto de Recogida',
        postal_code: 'Código Postal de Punto de Recogida',
        country: 'País de Punto de Recogida',
        carrier: 'Transportista de Punto de Recogida',
        code: 'Código de Punto de Recogida',
        latitude: 'Latitud de Punto de Recogida',
        longitude: 'Longitud de Punto de Recogida',
      },
    },
  },
};
